import React from "react";
import { useI18n } from "../i18n/i18n";

export default function ExerciseFlowSteps({ activeStep = 1 }) {
    const { t } = useI18n();

    const steps = [
        {
            number: t("select.stepOneNumber"),
            text: t("select.stepOneText"),
        },
        {
            number: t("select.stepTwoNumber"),
            text: t("select.stepTwoText"),
        },
    ];

    return (
        <div className="exerciseFlowSteps" aria-label={t("select.stepsTitle")}>
            {steps.map((step, index) => {
                const isActive = index + 1 === activeStep;
                const isCompleted = index + 1 < activeStep;
                const isLast = index === steps.length - 1;

                return (
                    <div
                        key={step.number}
                        className={`exerciseFlowStep${isActive ? " exerciseFlowStep--active" : ""}${isCompleted ? " exerciseFlowStep--completed" : ""}${isLast ? " exerciseFlowStep--last" : ""}`}
                        aria-current={isActive ? "step" : undefined}
                    >
                        <span className="exerciseFlowStepNumber" aria-hidden="true">
                            <span>{step.number}</span>
                            {isCompleted && <span className="exerciseFlowStepCheck">{"\u2713"}</span>}
                        </span>
                        <span className="exerciseFlowStepText">{step.text}</span>
                    </div>
                );
            })}
        </div>
    );
}
